export const GET_LOGS = 'GET_LOGS'
